// angular
import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppService } from '../../app.service';
import { CoreService } from '../../core/core.service';
import { KlenicoMeService } from '../me.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MeDynamicReportService } from './dynamic-report.service';


@Component({
    selector: 'me-dynamic-report',
    templateUrl: './dynamic-report.component.html',
    styleUrls: ['./dynamic-report.component.scss'],
    providers: [MeDynamicReportService]
})

export class MeDynamicReportComponent implements OnInit {
    isSelectTherapist = true;
    therapists = [];
    language = 0;
    languages = [];
    url = 'dynamic-report/intro';
    contents = {};
    clusters = [];

    constructor(
        public appService: AppService,
        public coreService: CoreService,
        public meService: KlenicoMeService,
        public translate: TranslateService,
        public meDynamicReportService: MeDynamicReportService,
        public router: Router
    ) {
       
    }

    ngOnInit() {
        this.getDynamicReportCard();
        this.translate.onLangChange.subscribe(value => {
            this.getDynamicReportCard();
            this.getDynamicReport();
        });
    }

    getDynamicReport() {
        this.appService.isLoading = true;
        this.meDynamicReportService.getDynamicReport().subscribe(res => {
            this.clusters = res['clusters'];
            this.appService.isLoading = false;
        });
    }

    getDynamicReportCard() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.contents = contents;
            this.getDynamicReport();
        });
    }

    activeCluster(data) {
        this.router.navigate(['me/dynamic-report/clusters/' + data.slug]);
    }

    backToHome() {
        this.router.navigate(['me/dashboard'], {
            queryParams: {
                tab: 1
            }
        });
    }
}
